// extracted by mini-css-extract-plugin
export default {"outer":"Cans_outer__5dyX3","inner":"Cans_inner__IJizl","can":"Cans_can__0KqpC","fruit1":"Cans_fruit1__mnpmg","fruit2":"Cans_fruit2__orTPf"};